import { apiClient } from '../../../api';

// Credenciais (client_id / client_secret) da ApiForClient da ops atual
// (POST /apiForClientCredenciais, permissão apiForClientCredenciais). O backend
// prende cada credencial à ops em que foi criada.

export interface ApiCredencial {
  clientId: string;
  nome: string;
  // últimos 4 caracteres do secret — o secret inteiro só aparece ao criar/rotacionar
  secretFinal: string;
  status: 'ativa' | 'revogada';
  criadaEm: string; // ISO
  criadaPor?: string | null;
  ultimoTokenEm: string | null; // ISO
  revogadaEm?: string | null;
}

export interface CredencialComSecret {
  credencial: ApiCredencial;
  clientSecret: string;
}

const chamar = async <T>(ops: string, corpo: Record<string, unknown>): Promise<T> =>
  (await apiClient.post<T>('/apiForClientCredenciais', { ops, ...corpo })).data;

export const credenciaisService = {
  async listar(ops: string): Promise<ApiCredencial[]> {
    return (await chamar<{ credenciais: ApiCredencial[] }>(ops, { acao: 'listar' })).credenciais;
  },

  criar(ops: string, nome: string): Promise<CredencialComSecret> {
    return chamar(ops, { acao: 'criar', nome: nome.trim() });
  },

  // novo secret; o anterior e os tokens emitidos com ele deixam de valer na hora
  rotacionar(ops: string, clientId: string): Promise<CredencialComSecret> {
    return chamar(ops, { acao: 'rotacionar', clientId });
  },

  async revogar(ops: string, clientId: string): Promise<void> {
    await chamar(ops, { acao: 'revogar', clientId });
  },
};
